module.exports = __webpack_public_path__ + "images/file_icons_v2/ppt-f51fce50f7a782100b633f50b0e24368.svg";